module.exports = __webpack_public_path__ + "img/live.14a4fbc7.png";